module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__wrap--bg cmp-modal",
    class: {
      'is-active': _vm.annDetailModal
    },
    attrs: {
      "id": "ann-detail-template"
    }
  }, [_c('div', {
    staticClass: "modal-wrap-container modal-wd1020"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body-container"
  }, [_c('div', {
    staticClass: "table-wrap mt-0 border-top-none"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("공고 정보 테이블")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tbody', [(_vm.detail.BIZ_SE !== 'IN49008') ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("사업연도")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.BIZ_YEAR))])]) : _vm._e(), _vm._v(" "), (_vm.detail.BIZ_SE !== 'IN49008') ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("세부사업명")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.BIZNM))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("공고명")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.ANN_NM))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("공고 단계")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.ANN_RCRT_STAT_NM))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s((_vm.annKindType === 'IN' && _vm.compYn === 'Y') ? '단계' : '참여자 단계'))]), _vm._v(" "), _c('td', [(_vm.detail.BIZ_SE !== 'IN49003') ? _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("신청·접수 단계 : " + _vm._s(_vm.detail.APP_ING_CD_NM)), (_vm.detail.APP_DT) ? _c('span', [_vm._v(" (" + _vm._s(_vm.detail.APP_DT) + ")")]) : _vm._e()]), _vm._v(" "), _c('li', [_vm._v("심사·평가 단계 : " + _vm._s(_vm.detail.JUDGE_ING_CD_NM)), (_vm.detail.JUDGE_DT) ? _c('span', [_vm._v(" (" + _vm._s(_vm.detail.JUDGE_DT) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.annKindType === 'JB' || (_vm.annKindType === 'IN' && _vm.compYn !== 'Y')) ? _c('li', [_vm._v("교육 단계 : " + _vm._s(_vm.detail.EDU_ING_CD_NM)), (_vm.detail.EDUDRNG_ST && _vm.detail.EDUDRNG_ED) ? _c('span', [_vm._v(" (" + _vm._s(_vm.detail.EDUDRNG_ST) + "~" + _vm._s(_vm.detail.EDUDRNG_ED) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.annKindType === 'JB' || (_vm.annKindType === 'IN' && _vm.compYn !== 'Y')) ? _c('li', [_vm._v("활동 단계 : " + _vm._s(_vm.detail.ACT_ING_CD_NM)), (_vm.detail.ACTPER_ST && _vm.detail.ACTPER_ED) ? _c('span', [_vm._v(" (" + _vm._s(_vm.detail.ACTPER_ST) + "~" + _vm._s(_vm.detail.ACTPER_ED) + ")")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.detail.BIZ_SE === 'IN49003') ? _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("신청·접수 단계 : " + _vm._s(_vm.detail.APP_ING_CD_NM)), (_vm.detail.APP_DT) ? _c('span', [_vm._v(" (" + _vm._s(_vm.detail.APP_DT) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.detail.EDU_ING_STEP) ? _c('li', [_vm._v("참여 단계 : 참여완료")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("신청정보 조회")]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-gray btn-sm wid88",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAppViewModal
    }
  }, [_vm._v("조회")])])]), _vm._v(" "), (_vm.annKindType === 'JB' || (_vm.annKindType === 'IN' && _vm.compYn !== 'Y' && _vm.detail.BIZ_SE !== 'IN49008')) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("중도포기")]), _vm._v(" "), (_vm.annKindType == 'JB' && _vm.detail.SEQ == null && _vm.detail.CUR_STAT_CD != 'JB22001') ? _c('td', [_c('button', {
    staticClass: "btn btn-gray btn-sm wid88",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showGiveUpRegistModal
    }
  }, [_vm._v("포기")])]) : (_vm.annKindType == 'IN' && _vm.detail.SEQ == null && (_vm.detail.CUR_STAT_CD == 'IN22002' || _vm.detail.CUR_STAT_CD == 'IN22003' || _vm.detail.CUR_STAT_CD == 'IN22004')) ? _c('td', [_c('button', {
    staticClass: "btn btn-gray btn-sm wid88",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showGiveUpRegistModal
    }
  }, [_vm._v("포기")])]) : _c('td', [_vm._v(_vm._s(_vm.detail.GIVEUP_CD_NM))])]) : _vm._e(), _vm._v(" "), (_vm.annKindType === 'JB' || (_vm.annKindType === 'IN' && _vm.compYn !== 'Y')) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("활동 확인서")]), _vm._v(" "), _c('td', [(_vm.detail.PRINT_CHK == 'P') ? _c('button', {
    staticClass: "btn btn-gray btn-sm wid88",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.actJnlReport
    }
  }, [_vm._v("출력")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("취소 신청")]), _vm._v(" "), (_vm.annKindType == 'JB' && _vm.detail.CUR_STAT_CD == 'JB22001' && _vm.detail.APP_ING_CD == 'JB21002' && _vm.detail.ANN_RCRT_STAT == 'JB17003') ? _c('td', [_c('button', {
    staticClass: "btn btn-gray btn-sm wid88",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.appCancle
    }
  }, [_vm._v("신청 취소")])]) : (_vm.annKindType == 'IN' && (_vm.detail.CUR_STAT_CD == 'IN22001' || _vm.detail.CUR_STAT_CD == 'IN42001') && (_vm.detail.APP_ING_CD == 'IN21001' || _vm.detail.APP_ING_CD == 'IN21002')) ? _c('td', [_c('button', {
    staticClass: "btn btn-gray btn-sm wid88",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.appCancle
    }
  }, [_vm._v("신청 취소")])]) : _c('td')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-md button-wid150 close-modal",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        닫기\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToAnnDetail
    }
  }, [_vm._v("\n        공고 바로가기\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon close-modal",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "title": "닫기"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])]), _vm._v(" "), _c('app-view-modal', {
    attrs: {
      "appViewModal": _vm.appViewModal,
      "annKindType": _vm.annKindType,
      "appNo": _vm.detail.APP_NO,
      "annNo": _vm.detail.ANN_NO,
      "bizSe": _vm.detail.BIZ_SE
    },
    on: {
      "update:appViewModal": function($event) {
        _vm.appViewModal = $event
      }
    }
  }), _vm._v(" "), _c('giveup-regist-modal', {
    attrs: {
      "detail": _vm.detail,
      "annKindType": _vm.annKindType,
      "giveUpRegistModal": _vm.giveUpRegistModal
    },
    on: {
      "update:giveUpRegistModal": function($event) {
        _vm.giveUpRegistModal = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("공고 상세 정보")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "180px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-235db69a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/APP/AnnDetail.vue
// module id = 1324
// module chunks = 6